
























































































import Vue from 'vue';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import MStoreFormSelect from '@/components/shared/MStoreFormSelect.vue';
import MStoreFormLookup from '@/components/shared/MStoreFormLookup.vue';
import MStoreFormDatePicker from '@/components/shared/MStoreFormDatePicker.vue';
import { LeaversService } from '@/services/LeaversTool/LeaversService';
import { LeaversToolConfigurationsService } from '@/services/LeaversTool/LeaversToolConfigurationsService';
import { LeaversToolConfigurationsModel, LeaversToolConfigurationModel, LeaverCreateModel } from '@/types';
import SnotifyConfiguration from '@/classes/SnotifyConfiguration';
import { FormFieldValidation } from '@/mixins/formValidation';
import { ProcessLeaver, ObjectHelper } from '@/mixins';

export default Vue.extend({
  name: 'ProcessLeavers',
  mixins: [FormFieldValidation, ProcessLeaver, ObjectHelper],
  inject: ['$validator'],
  data() {
    return {
      configurations: {} as LeaversToolConfigurationsModel,
      isPageLoading: false,
      isLoading: false,
      currentListId: 0,
      leaverId: '',
      leavingDate: '',
      leaverDetails: '',
      configurationId: 0
    };
  },
  methods: {
    async loadConfigurations() {
      this.$validator.reset();
      this.$validator.errors.clear();
      await LeaversToolConfigurationsService.getAllAsync().then(async (result: LeaversToolConfigurationsModel) => {
        if (result.configurationExists) {
          this.configurations = result;
          this.configurationId = result.configurations[0].id;
          this.currentListId = result.configurations[0].currentListConfiguration.id;
        }
      });
    },
    async handleSubmit(this: any) {
      this.$bvModal
        .msgBoxConfirm('Are you sure you want to process this leaver?' + ' If you proceed, then any documents that are indexed against' + ' this leaver in the future will not be moved across.', {
          title: 'Are you sure?',
          cancelVariant: 'danger'
        })
        .then(async (result: boolean) => {
          if (result) {
            this.isLoading = true;
            await LeaversService.createAsync(this.leaver)
              .then(async (result: any) => {
                SnotifyConfiguration.showSuccess('Leaver added successfully.');
                await this.loadConfigurations();
                this.isLoading = false;
                this.setApplicationDirty(false);
              })
              .catch((error) => {
                this.isLoading = false;
              });
          }
        });
    },
    onUpdateLeaverList(this: any, value: any) {
      this.leaverId = value;
    },
    onRowSelected(this: any, row: any) {
      if (this.isNullOrEmpty(row) || row.length === 0) {
        return;
      }
      this.leaverDetails = Object.values(row).join('|');
    },
    onUpdateLeavingDate(this: any, value: any) {
      this.leavingDate = value;
    },
    cancel() {
      this.$router.push({ name: 'processLeaverHistory' });
    }
  },
  computed: {
    configurationsDropdownOptions(this: any) {
      return this.configurations.configurationExists
        ? this.configurations.configurations.map((configuration: LeaversToolConfigurationModel) => ({
            id: configuration.id,
            description: this.getLeaverDescription(configuration.currentCabinet, configuration.destinationCabinet)
          }))
        : [];
    },
    leaver(this: any): LeaverCreateModel {
      return {
        listItemValue: this.leaverId,
        details: this.leaverDetails,
        leavingDate: this.leavingDate,
        configurationId: this.configurationId
      } as LeaverCreateModel;
    }
  },
  async mounted(this: any) {
    this.isPageLoading = true;
    await this.loadConfigurations();
    this.isPageLoading = false;
  },
  components: {
    MStoreFormDatePicker,
    LoadingSpinner,
    MStoreFormSelect,
    MStoreFormLookup
  }
});
